import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import {
  faBuilding,
  faCalendarAlt,
  faEarth,
  faFileAlt,
  faHandshake,
  faLayerGroup,
  faRoute,
  faUser,
  faUserCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

import { EntityType } from "@mapmycustomers/shared/enum";

import TerritoriesIcon from "../assets/territories.jsx.svg";

interface EntityTypeIconProps extends Omit<FontAwesomeIconProps, "icon"> {
  entityType: "universal" | EntityType;
}

const EntityTypeIcon = ({ entityType, ...fontAwesomeIconProps }: EntityTypeIconProps) => {
  let icon: IconDefinition | undefined = undefined;

  switch (entityType) {
    case EntityType.ACTIVITY:
      icon = faCalendarAlt;
      break;

    case EntityType.COMPANY:
      icon = faBuilding;
      break;

    case EntityType.COMPANY_GROUP:

    // eslint-ignore-next-line no-fallthrough
    case EntityType.DEAL_GROUP:
    case EntityType.PEOPLE_GROUP:
      icon = faLayerGroup;
      break;
    case EntityType.COMPANY_ROUTE:

    // eslint-ignore-next-line no-fallthrough
    case EntityType.PEOPLE_ROUTE:
    case EntityType.ROUTE:
      icon = faRoute;
      break;
    case EntityType.DEAL:
      icon = faHandshake;
      break;

    case EntityType.PERSON:
      icon = faUser;
      break;
    case EntityType.RESOURCE:
      icon = faFileAlt;
      break;
    case EntityType.TERRITORY:
      return <TerritoriesIcon className={fontAwesomeIconProps.className} />;
    case EntityType.USER:
      icon = faUserCircle;
      break;
    case "universal":
      icon = faEarth;
      break;
  }

  return icon ? <FontAwesomeIcon {...fontAwesomeIconProps} icon={icon} /> : null;
};

export default EntityTypeIcon;
